import loadStyleSheet from '@gef-ui/utils/loadStyleSheet';

export const loadAppCSS = async () => {
	if (__DEV__) {
		require('components/assets/scss/gcptheme.scss');
	} else {
		await loadStyleSheet(`/cp_${process.env.APP_GIT_COMMITHASH}.css`);
	}
};
